"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CopyToClipboard;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function CopyToClipboard(props) {
  const {
    t
  } = props;
  const [open, setOpen] = (0, _react.useState)(false);
  const {
    toBeCopied,
    child
  } = props;
  const handleClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(toBeCopied);
  };
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: t('copy_clipboard')
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    onClick: handleClick,
    sx: {
      cursor: 'pointer'
    }
  }, child, /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    open: open,
    onClose: () => setOpen(false),
    autoHideDuration: 2000,
    message: t('copied_clipboard')
  })));
}